import moment from 'moment'
import Bugsnag from '../plugins/bugsnag'
import {params} from '../localData'

moment.parseTwoDigitYear = function (yearString) {
  var year = parseInt(yearString)
  return (year > 22 ? 1900 : 2000) + year
}

export const getFromLocal = keyName => {
  return localStorage.getItem(keyName)
}
export const setToLocalStorage = ({ key, value }) => {
  return localStorage.setItem(key, value)
}

export const getLocale = () => {
  let browserLocale = window.navigator.userLanguage || window.navigator.language
  return browserLocale.split('-')[0]
}

export const getRandomiseFlowDecision = percent => {
  let decisionStatus
  if (Math.random() < percent / 100) {
    decisionStatus = true
  } else {
    decisionStatus = false
  }
  return decisionStatus
}

export const setCookie = (cname, cvalue, exdays, isLiliDomain = false) => {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + `${isLiliDomain ? ';domain=.lili.co' : ''}` + ';path=/'
}

export const getCookie = cname => {
  var name = cname + '='
  try {
    var decodedCookie = decodeURIComponent(document.cookie)
  } catch (e) {
    return ''
  }
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const isLocalStorage = () => {
  try {
    window.localStorage.setItem('storageTest', true)
    return true
  } catch (e) {
    return false
  }
}

export const uppercaseFirstLetter = data => {
  let value = data.charAt(0).toUpperCase() + data.slice(1)
  return value
}

export const formatDateToISO = date => {
  return moment.parseZone(date, 'MM/DD/YYYY').toISOString()
}

export const isFromLiliApp = () => {
  let origins = ['Lili', 'liliapp']
  let status = false
  origins.map(origin => {
    if (navigator.userAgent.toLowerCase().includes(origin.toLowerCase())) {
      status = true
    }
  })
  return status
}

export const getDeviceType = () => {
  let type
  if (
    !!navigator.userAgent &&
    /iPad|iPhone|iPod|MacIntel/.test(navigator.userAgent)
  ) {
    type = 'ios'
  } else if (
    !!navigator.userAgent &&
    /android|Android/i.test(navigator.userAgent)
  ) {
    type = 'android'
  } else {
    type = 'unknown'
  }
  return type
}

export const hash = async string => {
  try {
    const utf8 = new TextEncoder().encode(string)
    const hashBuffer = await crypto.subtle.digest('SHA-256', utf8)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray
      .map(bytes => bytes.toString(16).padStart(2, '0'))
      .join('')
    return hashHex
  } catch (err) {
    Bugsnag.notify('Hash exception: ', JSON.stringify(err))
  }
}
export const decodeURI = (data, rounds) => {
  let decodeRounds = rounds
  let decodedData = data
  try {
    for (let i = 1; i <= decodeRounds; i++) {
      decodedData = decodeURIComponent(decodedData)
    }
    return decodedData
  } catch (error) {
    console.log(error)
    return data
  }
}

export const updateCustomerStep = async (store, step, accessToken, customerId) => {
  try {
    await store.dispatch('customer/updateCustomer', {
      method: 'post',
      endPoint: `v3/secureonboarding/partner/user/${customerId}/step`,
      data: {
        step: step,
        version: params.stepVersion
      },
      header: {
        headerName: params.httpHeaders.auth,
        headerValue: `lili ${accessToken}`
      }
    })
  } catch (error) {
    console.error('Error updating customer step:', error)
  }
}



// WEBPACK FOOTER //
// ./src/services/UtilService.js